import React, { FC } from "react";
import "./MinimizeButton.scss";

export interface MinimizeButtonProps {
    onClick(): void;
    showInRight: boolean;
    tabIndex?: string;
}

const MinimizeButton: FC<MinimizeButtonProps> = (props) => {
    return (
        <button
            id="xapp-widget-minimize"
            aria-label={"minimize widget"}
            aria-hidden={false}
            tabIndex={props.tabIndex ? Number(props.tabIndex) : 0}
            className={`minimize-button ${props.showInRight ? "positionRight" : ""}`}
            onClick={props.onClick}></button>
    );
};

export default MinimizeButton;
